import axios, { AxiosInstance } from "axios";

const promoCodeAxios: AxiosInstance = axios.create({
  baseURL: process.env.REACT_APP_Promo_Code_API_URL,
});

// Request interceptor
promoCodeAxios.interceptors.request.use(
  (req) => {
    req.headers["x-api-key"] = "7uzF^sQSUqnwhe70SOOc$f^6$*UGZTylwzUCBGqE";

    return req;
  },

  (error) => Promise.reject(error)
);

// Response interceptor (optional if you want to handle other types of errors here)
promoCodeAxios.interceptors.response.use(
  (response) => {
    return response;
  },

  (error) => Promise.reject(error)
);

export default promoCodeAxios;
